import UserTemplate from './template/UserTemplate'


const UserPage = (props) =>{
  return (
    <>
      <UserTemplate   login={props.login} index={2} title={"一般ユーザ一覧"}　/>
    </>
  );
}

export default UserPage;